import { IOperativeStandardsSettingsSchema } from '../operative-standards-settings.interface';

export type IOperativeStandardsInput = IOperativeStandardsSettingsSchema;
